import { render, staticRenderFns } from "./wechat-quick-login.vue?vue&type=template&id=1f5d3429&scoped=true";
import script from "./wechat-quick-login.vue?vue&type=script&lang=js";
export * from "./wechat-quick-login.vue?vue&type=script&lang=js";
import style0 from "./wechat-quick-login.vue?vue&type=style&index=0&id=1f5d3429&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "1f5d3429", null);
export default component.exports;